import { render } from "./NoQuotesFound.vue?vue&type=template&id=08a42571&ts=true"
import script from "./NoQuotesFound.vue?vue&type=script&lang=ts"
export * from "./NoQuotesFound.vue?vue&type=script&lang=ts"

import "./NoQuotesFound.vue?vue&type=style&index=0&id=08a42571&lang=css"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__